import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import './index.scss';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import store from 'store';
import ErrorWrapper from 'components/ErrorHandling/ErrorWrapper';
import LinkInterceptor from 'components/LinkInterceptor/LinkInterceptor';
import * as Sentry from '@sentry/react';

// react-redux@7 and react-router-dom@5 type their components without an explicit
// `children` prop (relying on the implicit children React <18 types used to add
// to every component). @types/react 18 removed that implicit children, so these
// need a local cast to keep accepting JSX children.
const TypedProvider = Provider as unknown as React.FC<React.PropsWithChildren<{ store: typeof store }>>;
const TypedRouter = Router as unknown as React.FC<React.PropsWithChildren<unknown>>;

if (process.env.REACT_APP_SENTRY_DSN !== '') {
    Sentry.init({
        release: process.env.REACT_APP_SENTRY_RELEASE,
        dsn: process.env.REACT_APP_SENTRY_DSN
    });
}

ReactDOM.render(
    <React.StrictMode>
        <TypedProvider store={store}>
            <ErrorWrapper>
                <TypedRouter>
                    <LinkInterceptor />
                    <App />
                </TypedRouter>
            </ErrorWrapper>
        </TypedProvider>
    </React.StrictMode>,

    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
